import React from "react";
import ItemToBuyBlock from "./ItemToBuyBlock";
import "../../styles/items-to-buy/items-to-buy.css"


class ItemsToBuy extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      items: [
        {
          title: 'Ледниковая свежесть',
          description: 'Протеины шелка, кератин, керамиды, морская и ледниковая вода – всё это \n' +
              'и\n' +
              'ещё немного больше вы найдете внутри этого бокса. Он направлен \n' +
              'на\n' +
              'тщательное увлажнение и восстановление волос и кожи головы. Средства в наборе помогают в кратчайшие сроки устранить сухость, ломкость \n' +
              'и\n' +
              'предотвратить сечение прядей. Уплотняют, смягчают, наполняют волосы\n' +
              'влагой, делая их мягкими и шелковистыми. С помощью расчески выполняется лимфодренажный массаж кожи головы, способствующий росту волос.\n',
          price: '980 рублей',
          img: '/itemToBuy1.jpg'
        },
        {
          title: 'Полное наслаждение',
          description: 'Церамиды, центелла и муцин улитки, травы, алоэ – одни из самых ценных компонентов в корейской косметике. В наборе собраны успокаивающие, очищающие, заживляющие, балансирующие средства, которые одинаково эффективны на любых типах кожи, в том числе чувствительной. В наборе есть полноразмерные средства и миниатюры популярных корейских брендов. Гель для душа мягко очищает кожу, дарит ощущение чистоты и свежести. \n' +
              'Не содержит парабенов, спирта, минерального масла. Пенка для умывания тщательно очищает кожу от остатков макияжа и увлажняет ее, не вызывает чувства сухости и стянутости кожи после умывания. Маски для лица глубоко увлажняют на дневном и ночном этапах ухода. Все средства имеют богатый натуральный состав и высокую эффективность.',
          price: '1180 рублей',
          img: '/itemToBuy2.jpg'
        },
        {
          title: 'Красота и сияние',
          description: 'Набор включает в себя маску и воздушную пенку для лица, которая подойдет даже для чувствительной кожи. Пенка оказывает глубоко увлажняющее и успокаивающее действие. Маска с роскошным составом, включающим в себя комплекс из растительных экстрактов полыни, зеленого чая, алоэ, центеллы азиатской и масла лаванды, уменьшает раздражение, успокаивает, увлажняет кожу и стимулирует процессы регенерации. При комплексном применении средства набора обеспечивают повышение упругости и эластичности, выравнивают цвет лица, рельеф и в целом улучшают состояние кожи. Подходит для любого возраста и типа кожи.',
          price: '1180 рублей',
          img: '/itemToBuy3.jpg'
        },
        {
          title: 'Магия манго',
          description: 'Эффективные и универсальные средства для кожи головы и лица. Шампунь и маска с экстрактом манго эффективно восстанавливают структуру волос, а также интенсивно увлажняют и питают их, делая ваши локоны здоровыми и эластичными. Натуральный состав средств защищает волосы от преждевременного старения, делает их мягкими и шелковистыми. Расческа легко справится с самыми запутанными волосами, а питательная маска для лица содержит огромное количество витаминов и питательных веществ, которые увлажняют кожу и способствуют ее укреплению. ',
          price: '1180 рублей',
          img: '/itemToBuy4.jpg'
        },
        {
          title: 'Ягодное наслаждение',
          description: 'В этом боксе спрятана сила натуральных ингредиентов для бережного очищения кожи головы и насыщения волос естественным сиянием. Экстракты ягод и фруктов питают волосы витаминами, а природные фруктовые кислоты оказывают отшелушивающий эффект, который избавит \n' +
              'от жирного блеска и перхоти. Средства направлены на оздоровление раздраженной кожи, устранение ороговевшего слоя, увлажнение \n' +
              'и восстановление упругости волос. Мы подобрали для вас комбинацию продуктов для качественного восстановления ослабленных волос.',
          price: '1200 рублей',
          img: '/itemToBuy5.jpg'
        },
        {
          title: 'Утренний ритуал красоты',
          description: 'Правильный уход для лица – залог красивой и здоровой кожи. Данный набор состоит из эффективных средств для вашего утреннего ритуала красоты. Питательная маска для лица создаёт на поверхности кожи защитный барьер, а активные компоненты корейских гидрогелевых патчей устраняют следы недосыпа, снимают отечность, разглаживают мелкие морщинки вокруг глаз \n' +
              'и обеспечивают стойкий эффект.',
          price: '1480 рублей',
          img: '/itemToBuy6.jpg'
        },
        {
          title: 'Четкий контур',
          description: 'Набор инновационных продуктов для упругости кожи и мощного лифтинг-эффекта. Сыворотка, содержащая гиалуроновую кислоту в сочетании \n' +
              'с комплексом масел и мезороллер, включающий себя несколько техник ручного массажа, помогают в борьбе с возрастными изменениями кожи, уменьшают отечность и способствуют улучшению тона кожи за счет усиления притока крови. Средства эффективно борются с морщинами и подтягивают рельеф. Результат: подтянутая кожа, насыщенная влагой и питательными веществами.',
          price: '2480 рублей',
          img: '/itemToBuy7.jpg'
        },
      ],
    };
  }

  render() {
    return (
      <div id="items" className="items-to-buy">
        <ul className="ul-reset">
          {this.state.items.map((item, index) =>
              <ItemToBuyBlock key={item.title}
                              title={item.title}
                              description={item.description}
                              price={item.price}
                              img={item.img}
                              isFirstColText={! (index % 2)}
              />)}
        </ul>
      </div>
    );

  }

}

export default ItemsToBuy;
